import { color, Link, spacing, typography } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled(Link)`
  ${typography('caption1')};
  display: flex;
  align-items: center;
  padding: ${spacing(2, 3)};
  color: ${color('white')};
  background-color: rgba(0, 0, 100, 0.6);
`

export const Text = styled.span`
  margin-left: ${spacing(2)};
`
